import { css } from '@emotion/react';
import { COLORS2 } from '../Styles';

const OUTER_RING_SIZE = 24;
const INNER_RING_SIZE = 12;
const RADIO_ICON_WIDGET_STYLE = css`
  label: RADIO_ICON_WIDGET_STYLE;
  width: ${OUTER_RING_SIZE}px;
  height: ${OUTER_RING_SIZE}px;
  background: white;
  border: 2px solid ${COLORS2.alwaysDark.charcoal};
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: -4px;
    border: 2px solid transparent;
    border-radius: 50%;
    transition: border-color 0.15s ease;
  }

  &:hover::before {
    border-color: ${COLORS2.alwaysDark.darkGray};
  }
`;

const RADIO_ICON_WIDGET_CHECKED_STYLE = css`
  label: RADIO_ICON_WIDGET_CHECKED_STYLE;
  &::after {
    content: '';
    width: ${INNER_RING_SIZE}px;
    height: ${INNER_RING_SIZE}px;
    background: ${COLORS2.alwaysDark.charcoal};
    border-radius: 50%;
  }
`;

export const RadioIconWidget = ({ checked, onChange }: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <div
    css={[RADIO_ICON_WIDGET_STYLE, checked && RADIO_ICON_WIDGET_CHECKED_STYLE]}
    onClick={() => onChange(!checked)}
  />
);
